import { Pipe, PipeTransform } from '@angular/core';
import { safeToNumber } from '../utils/typeconversions';

@Pipe({
  name: 'reduceDecimals'
})
export class ReduceDecimalsPipe implements PipeTransform {

  transform(value: number | string | null, reduceNumber: number): any {
    const x = safeToNumber(value)
    if (x == null) {
      return '--'
    }
    return x.toFixed(reduceNumber);

  }

}
